<template>
	<div>
		<div class="particulars-head">
			<div class="particulars-head-con">
				<div class="particulars-head-con-left">
					<router-link to="index">
						<img src="../../img/logo.png" alt class="particulars-logo" />
					</router-link>
					<router-link to="Cartoon">
						<p class="particulars-p">
							{{cateLink.catename}}
							<span class="particulars-span">></span>
						</p>
					</router-link>
					<p class="particulars-p1" @click="toCartooninfo(cateLink.id)">
						{{cateLink.title}}
						<span class="particulars-span">></span>
					</p>
					<p class="particulars-p">{{content.title}}</p>
				</div>
				<!--未登录  -->
				<div class="particulars-head-con-right" v-if="!show">
					<div class="particulars-div">
						<input
							type="text"
							class="particulars-input"
							placeholder="搜索"
							v-model="searchtitle"
							@keyup.enter="tosearch"
						/>
						<img src="../../img/ss.png" alt class="particulars-ss" @click="tosearch" />
					</div>
					<img src="../../img/use.png" alt class="particulars-use" />
					<div class="particulars-div1">
						<router-link to="/login">
							<p class="particulars-div1-p">登录</p>
						</router-link>
						<p class="particulars-div1-p">/</p>
						<router-link to="/login">
							<p class="particulars-div1-p">注册</p>
						</router-link>
					</div>
				</div>
				<!-- 已登录 -->
				<div class="particulars-head-con-right" v-if="show">
					<div class="particulars-div">
						<input
							type="text"
							class="particulars-input"
							placeholder="搜索"
							v-model="searchtitle"
							@keyup.enter="tosearch"
						/>
						<img src="../../img/ss.png" alt class="particulars-ss" @click="tosearch" />
					</div>
					<img src="../../img/use.png" alt class="particulars-use" />
					<div class="particulars-div1">
						<div @click="logout">退出</div>
					</div>
				</div>
			</div>
		</div>
		<div class="particulars-con">
			<div class="particulars-con-div">
				<div v-for="(item, index) in content.info" :key="index">
					<img :src="item" alt class="particulars-con-div-img" />
				</div>
				<div class="particulars-dw">
					<div>
						<img src="../../img/ml.png" alt class="particulars-dw-img" />
						<p class="particulars-dw-p">目录</p>
					</div>
					<div class="particulars-dw-div">
						<img src="../../img/adf.png" alt class="particulars-dw-img1" />
						<p class="particulars-dw-p1">上一章</p>
					</div>
					<div class="particulars-dw-div">
						<img src="../../img/yyyyyy.png" alt class="particulars-dw-img1" />
						<p class="particulars-dw-p1">下一章</p>
					</div>
				</div>
				<div class="particulars-con-div-div">
					<div class="particulars-con-div-div-div">
						<img src="../../img/left.png" alt class="particulars-leftimg" />
						<p class="particulars-leftp" @click="toPrev()">上一章</p>
					</div>
					<div class="particulars-con-div-div-div">
						<p class="particulars-conp">{{content.ji_no}}/{{count}}话</p>
					</div>
					<div class="particulars-con-div-div-div1">
						<img src="../../img/right.png" alt class="particulars-leftimg" />
						<p class="particulars-leftp" @click="toNext()">下一章</p>
					</div>
				</div>
				<!-- <div class="particulars-foot">
					<button type="button" class="particulars-btn">打赏</button>
				</div>-->
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "App",
		components: {},
		data() {
			return {
				cateLink: "",
				content: "",
				count: "",
				prev: "",
				next: "",
				show: false
			};
		},
		methods: {
			toPrev() {
				if (this.prev) {
					this.$http.get("cartoon/data/" + this.prev).then(res => {
						this.content = res.body.data.content;
						this.prev = res.body.data.prev;
						this.next = res.body.data.next;
					});
				}
			},
			toNext() {
				if (this.next) {
					this.$http.get("cartoon/data/" + this.prev).then(res => {
						this.content = res.body.data.content;
						this.prev = res.body.data.prev;
						this.next = res.body.data.next;
					});
				}
			},
			toCartooninfo(id) {
				this.$router.push({
					name: "Catalog",
					query: { id: id }
				});
			},
			logout() {
				this.$http
					.post(`user/logout`, {
						token: this.$cookies.get("token")
					})
					.then(res => {
						if (res.body.code == 1) {
							this.$cookies.remove("token");
							this.show = false;
						}
					});
			},
			tosearch() {
				if (this.searchtitle) {
					const serach = this.$router.resolve({
						path: "/searchzixun",
						query: { searchtitle: this.searchtitle }
					});
					window.open(serach.href, "_blank");
				}
			}
		},
		created() {
			// 漫画
			this.$http.get("cartoon/data/" + this.$route.query.id).then(res => {
				this.cateLink = res.body.data.cateLink;
				this.content = res.body.data.content;
				this.count = res.body.data.count;
				this.prev = res.body.data.prev;
				this.next = res.body.data.next;
			});
			if (this.$cookies.isKey("token")) {
				this.show = true;
				console.log("show", this.show);
			} else {
				this.show = false;
			}
		}
	};
</script>

<style>
	.particulars-head {
		width: 100%;
		height: 70px;
		background-color: #1a1a1a;
		box-sizing: border-box;
		padding: 0 80px;
	}
	.particulars-con {
		width: 100%;
		padding: 40px;
		box-sizing: border-box;
		background-color: #212121;
		display: flex;
		justify-content: center;
	}
	.particulars-head-con {
		display: flex;
		justify-content: space-between;
	}
	.particulars-head-con-left {
		height: 70px;
		display: flex;
		align-items: center;
	}
	.particulars-logo {
		width: 140px;
		height: 46px;
		margin-right: 20px;
	}
	.particulars-p {
		font-size: 22px;
		color: #999999;
	}
	.particulars-p1 {
		font-size: 22px;
		color: #ffffff;
		cursor: pointer;
	}
	.particulars-span {
		font-size: 16px;
		color: #999999;
	}
	.particulars-head-con-right {
		display: flex;
		align-items: center;
		height: 70px;
	}
	.particulars-div {
		position: relative;
	}
	.particulars-input {
		width: 240px;
		height: 36px;
		padding-left: 16px;
		border-radius: 18px;
		background-color: #b3b3b3;
		font-size: 16px;
		border: 0;
	}
	.particulars-ss {
		width: 20px;
		height: 20px;
		position: absolute;
		top: 8px;
		right: 16px;
	}
	.particulars-use {
		width: 34px;
		height: 34px;
		margin: 0 10px;
	}
	.particulars-div1 {
		display: flex;
	}
	.particulars-div1 div {
		color: #999999;
		cursor: pointer;
	}
	.particulars-div1-p {
		font-size: 22px;
		color: #999999;
	}
	.particulars-con-div {
		width: 960px;
		position: relative;
	}
	.particulars-con-div-img {
		width: 960px;
		height: 1400px;
	}
	.particulars-con-div-div {
		width: 420px;
		height: 50px;
		border-radius: 25px;
		background-color: #ff2853;
		margin: 40px auto;
		box-sizing: border-box;
		padding: 0 20px;
		display: flex;
		justify-content: space-around;
	}
	.particulars-con-div-div-div {
		display: flex;
		margin-right: 20px;
		align-items: center;
	}
	.particulars-con-div-div-div1 {
		display: flex;
		align-items: center;
	}
	.particulars-leftimg {
		width: 24px;
		height: 24px;
		margin-right: 10px;
	}
	.particulars-leftp {
		font-size: 22px;
		color: #fff;
	}
	.particulars-conp {
		font-size: 14px;
		color: #fff;
	}
	.particulars-btn {
		width: 70px;
		height: 70px;
		background: rgba(247, 242, 232, 1);
		border-radius: 50%;
		border: 0;
		font-size: 16px;
		font-weight: bold;
		margin: 0 auto;
	}
	.particulars-foot {
		display: flex;
		justify-content: center;
	}
	.particulars-dw {
		width: 70px;
		height: 306px;
		border-radius: 6px;
		background-color: #292929;
		position: absolute;
		bottom: 230px;
		right: -110px;
		box-sizing: border-box;
		padding: 18px 10px;
	}
	.particulars-dw-img {
		width: 34px;
		height: 34px;
		margin: 0 auto;
	}
	.particulars-dw-img1 {
		width: 18px;
		height: 34px;
		margin: 0 auto;
	}
	.particulars-dw-p {
		font-size: 16px;
		color: #666666;
		text-align: center;
		margin-top: 10px;
	}
	.particulars-dw-p1 {
		font-size: 14px;
		color: #666666;
		text-align: center;
		margin-top: 10px;
	}
	.particulars-dw-div {
		margin-top: 40px;
	}
</style>



// WEBPACK FOOTER //
// src/components/Cartoon/particulars.vue